import type { CarrierLogoProps } from './types'
import LogoSvg from '../../assets/carrier-logos/wizmo-logo.svg?react'
import { chakra } from '../../chakra'
import { getLogoProps } from './use-logo-props'
import * as React from 'react'

const Logo = chakra(LogoSvg)

export const WizmoLogo = React.forwardRef<SVGSVGElement, CarrierLogoProps>(
  function WizmoLogo(props, ref) {
    const logoProps = getLogoProps(props)

    return <Logo {...logoProps} ref={ref} />
  },
)
